import { sleep } from '@flowus/common/async';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { request } from 'src/common/request';

export type UnreadState = Record<
  string,
  { mention: number; inbox: number; share: number; subscribe: number }
>;

// spaceId -> unread number
export const unreadState = atom({} as UnreadState);

export const useUnreadState = () => useAtomValue(unreadState);

export const useRefreshUnreadState = () => {
  const setUnreadState = useSetUnreadState();
  return useCallback(
    async (spaceId?: string) => {
      await sleep(500);
      const res = await request.editor.getNotificationUnreadCount(spaceId);
      setUnreadState(res.results);
      return res;
    },
    [setUnreadState]
  );
};

export const useSetUnreadState = () => {
  const setUnread = useSetAtom(unreadState);
  return useCallback(
    (results: Awaited<ReturnType<typeof request.editor.getNotificationUnreadCount>>['results']) => {
      setUnread(() => {
        const unread: UnreadState = {};
        for (const result of results ?? []) {
          if (result.spaceId && result.unread) {
            unread[result.spaceId] = {
              mention: result.unread.mentions ?? 0,
              inbox: result.unread.inbox ?? 0,
              share: result.unread.sharing ?? 0,
              subscribe: result.unread.subscribe ?? 0,
            };
          }
        }
        return unread;
      });
    },
    [setUnread]
  );
};
